import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AdministradoresComponent } from './components/dashboard/administradores/administradores.component';
import { FacturacionesComponent } from './components/dashboard/facturaciones/facturaciones.component';
import { DeclaracionComponent } from './components/dashboard/declaraciones/declaracion/declaracion.component';
import { AltasComponent } from './components/dashboard/administradores/solicitudes/altas/altas.component';
import { SolicitudrepComponent } from './components/dashboard/administradores/solicitudes/representantes/solicitudrep/solicitudrep.component';
import { PasswordComponent } from './components/password/password.component';
import { DocumentosComponent } from './components/dashboard/administradores/documentos/documentos.component';
import { DocumentoaltaComponent } from './components/dashboard/administradores/solicitudes/altas/documentoalta/documentoalta.component';

const routes: Routes = [
	{ path: '', component: LoginComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'logout/:sure', component: LoginComponent },
	{ path: 'restaurar_cuenta/:code', component: PasswordComponent },
	{ path: 'dashboard', component: DashboardComponent },
	{ path: 'panel_de_control', component: AdministradoresComponent },
	{ path: 'dashboard/:section', component: DashboardComponent },
	{ path: 'panel_de_control/:section', component: AdministradoresComponent },
	{ path: 'datosFacturacion/:empresa_id', component: FacturacionesComponent },
	{ path: 'solicitudrep/:solicitudrep_id', component: SolicitudrepComponent },
	{ path: 'declaracion/:declaracion_id', component: DeclaracionComponent },
	{ path: 'documento/:declaracion_id', component: DocumentosComponent },
	{ path: 'documento_alta/:solicitud_id', component: DocumentoaltaComponent },
	{ path: '**', component: LoginComponent }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
